import { AudioRecordingObservable } from "@/store/audio-recordings";
import { AnyNoteVoiceSuggestion } from "@/store/note";

export const useAudioCaptureIndicatorBehavior = ({
  audioRecording,
  noteSuggestion,
  isExpanded,
  isInsideNote,
}: {
  audioRecording?: AudioRecordingObservable | null;
  noteSuggestion?: AnyNoteVoiceSuggestion | null;
  isExpanded: boolean;
  isInsideNote: boolean;
}) => {
  const shouldIncludeTextInLabel = isExpanded || isInsideNote;

  const displayDuration = (() => {
    if (!shouldIncludeTextInLabel) {
      return null;
    }

    if (audioRecording) {
      return audioRecording.formattedDuration;
    }

    if (noteSuggestion) {
      return "Voice";
    }

    return null;
  })();

  const shouldBeVisible = (() => {
    // If there is a note suggestion, it should be visible
    if (noteSuggestion) {
      return true;
    }

    if (audioRecording) {
      return true;
    }

    return false;
  })();

  return {
    shouldIncludeTextInLabel,
    displayDuration,
    shouldBeVisible,
  };
};
